class GiolippoStorySlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-story-track]');
    this.slides = Array.from(root.querySelectorAll('[data-story-slide]'));
    this.prevButton = root.querySelector('[data-story-prev]');
    this.nextButton = root.querySelector('[data-story-next]');
    this.dots = Array.from(root.querySelectorAll('[data-story-dot]'));
    this.currentIndex = 0;
    this.animating = false;
    this.enabled = Boolean(window.gsap) && this.slides.length > 1;

    if (!this.track || this.slides.length === 0) {
      return;
    }

    if (this.enabled) {
      this.prepare();
      this.bindEvents();
    }
  }

  prepare() {
    this.root.classList.add('is-slider-ready');
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === 0);
      const visual = slide.querySelector('[data-story-visual]');
      const content = slide.querySelector('[data-story-content]');

      window.gsap.set(slide, { autoAlpha: index === 0 ? 1 : 0 });
      if (visual) window.gsap.set(visual, { autoAlpha: 1, xPercent: 0 });
      if (content) {
        window.gsap.set(content, { autoAlpha: 1, yPercent: 0 });
        const children = Array.from(content.children || []);
        if (children.length) {
          window.gsap.set(children, {
            autoAlpha: index === 0 ? 1 : 0,
            yPercent: index === 0 ? 0 : 12,
          });
        }
      }
    });
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.showSlide(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.showSlide(this.currentIndex + 1));
    }
    if (this.dots.length) {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number(dot.dataset.storyDot);
          if (!Number.isNaN(targetIndex)) {
            this.showSlide(targetIndex);
          }
        });
      });
    }
  }

  showSlide(targetIndex) {
    if (!this.enabled || this.animating) return;

    const total = this.slides.length;
    const newIndex = (targetIndex + total) % total;
    if (newIndex === this.currentIndex) return;

    const direction = newIndex > this.currentIndex ? 1 : -1;
    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[newIndex];
    const currentVisual = currentSlide.querySelector('[data-story-visual]');
    const currentContent = currentSlide.querySelector('[data-story-content]');
    const nextVisual = nextSlide.querySelector('[data-story-visual]');
    const nextContent = nextSlide.querySelector('[data-story-content]');
    const currentTextItems = currentContent ? Array.from(currentContent.children || []) : [];
    const nextTextItems = nextContent ? Array.from(nextContent.children || []) : [];

    this.animating = true;
    nextSlide.classList.add('is-active');

    const timeline = window.gsap.timeline({
      defaults: { duration: 0.6, ease: 'power2.out' },
      onComplete: () => {
        currentSlide.classList.remove('is-active');
        window.gsap.set(currentSlide, { autoAlpha: 0 });
        window.gsap.set(nextSlide, { autoAlpha: 1 });
        this.currentIndex = newIndex;
        this.animating = false;
        this.updateDots();
      },
    });

    timeline.set(nextSlide, { autoAlpha: 1 });

    if (currentVisual) {
      timeline.to(
        currentVisual,
        { autoAlpha: 0, xPercent: -15 * direction },
        0
      );
    }
    if (currentContent) {
      timeline.to(
        currentContent,
        { autoAlpha: 0, yPercent: -8, duration: 0.35 },
        0
      );
    }
    if (currentTextItems.length) {
      timeline.to(
        currentTextItems,
        { autoAlpha: 0, yPercent: -10, duration: 0.35, stagger: 0.03 },
        0
      );
    }

    if (nextVisual) {
      timeline.fromTo(
        nextVisual,
        { autoAlpha: 0, xPercent: 15 * direction },
        { autoAlpha: 1, xPercent: 0 },
        0
      );
    }
    if (nextContent) {
      timeline.fromTo(
        nextContent,
        { autoAlpha: 0, yPercent: 15 },
        { autoAlpha: 1, yPercent: 0 },
        0.1
      );
    }
    if (nextTextItems.length) {
      timeline.fromTo(
        nextTextItems,
        { autoAlpha: 0, yPercent: 15 },
        { autoAlpha: 1, yPercent: 0, stagger: 0.08 },
        0.2
      );
    }
  }

  updateDots() {
    if (!this.dots.length) return;
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === this.currentIndex);
    });
  }
}

function initGiolippoStorySliders(scope = document) {
  const sliders = scope.querySelectorAll('[data-story-slider]');
  sliders.forEach((slider) => {
    if (!slider.__giolippoStorySlider) {
      slider.__giolippoStorySlider = new GiolippoStorySlider(slider);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initGiolippoStorySliders();
});

document.addEventListener('shopify:section:load', (event) => {
  initGiolippoStorySliders(event.target);
});
